import { useStandortContext } from '@/features/standortContext/StandortContext';
import { managerV1BaseUrl } from '@/utils';
import { ReactNode, useEffect } from 'react';

const NavigateToV1 = ({ destinationURL }: { destinationURL: string }) => {
  useEffect(() => {
    window.location.replace(destinationURL);
  }, [destinationURL]);
  return <></>;
};

export function WithLocationGuard({
  children,
  land,
  fallbackURL = managerV1BaseUrl,
}: {
  children: ReactNode;
  land: string;
  fallbackURL?: string;
}) {
  const { currentStandort } = useStandortContext();

  if (currentStandort?.land.toLowerCase() === land.toLowerCase()) {
    return children;
  }

  return <NavigateToV1 destinationURL={fallbackURL} />;
}
